import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/news';

export default function TrendingCards() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollPos, setScrollPos] = useState(0);

  const trending = newsArticles.filter((a) => a.isHot);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const scrollAmount = 340;
    const newPos = direction === 'left'
      ? Math.max(0, scrollPos - scrollAmount)
      : Math.min(
          scrollRef.current.scrollWidth - scrollRef.current.clientWidth,
          scrollPos + scrollAmount,
        );
    scrollRef.current.scrollTo({ left: newPos, behavior: 'smooth' });
    setScrollPos(newPos);
  };

  const canScrollLeft = scrollPos > 0;
  const canScrollRight = scrollRef.current
    ? scrollPos < scrollRef.current.scrollWidth - scrollRef.current.clientWidth - 10
    : true;

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full border border-accent-400/30 bg-accent-500/5 mb-4">
              <i className="ri-flashlight-line text-accent-400 text-xs"></i>
              <span className="text-accent-400 text-xs font-medium">热门爆料</span>
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              今日热门 · 吃瓜速递
            </h2>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300/30 text-foreground-500 hover:text-foreground-950 hover:border-foreground-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-300/30 text-foreground-500 hover:text-foreground-950 hover:border-foreground-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all duration-200 cursor-pointer"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={(e) => setScrollPos((e.target as HTMLDivElement).scrollLeft)}
          className="flex gap-5 overflow-x-auto scrollbar-hide pb-2"
          style={{ scrollSnapType: 'x mandatory' }}
        >
          {trending.map((article, idx) => (
            <Link
              key={article.id}
              to={`/detail/${article.id}`}
              className="group flex-shrink-0 w-[300px] md:w-[320px] bg-background-100 border border-foreground-200/15 rounded-xl overflow-hidden transition-all duration-300 hover:border-primary-500/40 cursor-pointer"
              style={{ scrollSnapAlign: 'start' }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`${article.title} - 51黑料吃瓜网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                {idx === 0 && (
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-bold rounded-md bg-primary-500 text-foreground-950">
                    HOT
                  </span>
                )}
                <span className="absolute bottom-3 left-3 px-2 py-0.5 text-xs rounded-full bg-foreground-950/20 backdrop-blur-sm text-foreground-800">
                  {article.category}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-heading font-bold text-foreground-800 text-base leading-snug group-hover:text-primary-400 transition-colors duration-300 line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <div className="flex items-center justify-between text-foreground-400 text-xs">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}